
import React from 'react';

import GridContainer from '../../mui-components/Grid/GridContainer';
import ItemGrid from '../../mui-components/Grid/GridItem';
import RegularCard from '../../mui-components/Card/RegularCard';
import TasksTable from '../../containers/domain/task/TasksTable';

const TasksListingView = () => (
  <GridContainer>
    <ItemGrid xs={12}>
      <RegularCard
        title="Lista de tarefas"
        content={<TasksTable />}
      />
    </ItemGrid>
  </GridContainer>
);

export default TasksListingView;
